import { type QueryStatus } from '@adv-frontend/modules-query';
import { type SettingsPrimitive, useSettingsPrimitive } from '#entities/merchSetting';

type StringSetting = Extract<SettingsPrimitive, { value: string | undefined }>;

const isStringSetting = (setting: SettingsPrimitive): setting is StringSetting =>
    setting.type === 'string' || setting.type === 'multiline' || setting.type === 'secret';

export const useVerificationCodeSetting = (
    path: string,
    { skip = false }: { skip?: boolean } = {}
): {
    queryStatus: QueryStatus;
    setting?: StringSetting;
    verificationCode: string;
} => {
    const { primitives, status } = useSettingsPrimitive({ paths: [path], skip });
    const setting = primitives.find(isStringSetting);
    const value = setting?.value;

    return {
        queryStatus: status,
        setting,
        verificationCode: typeof value === 'string' ? value.trim() : '',
    };
};
